import { memo, useMemo } from "react";
import { convertDate, formatDescription } from "../Board";
import { Link } from "react-router-dom";
import TaskList from "../components/TaskList";
import { formatRelativeDate } from "../../../helpers/dateHelper";
import moment from "moment";

export default memo(function ReporterTasks({ reporter = "" }) {
  const tasksHeaders = useMemo(() => {
    return [
      {
        field: "date",
        headerName: "Date create",
        sortable: false,
        type: "string",
        maxWidth: 150,
        flex: 1,
        renderCell: (params) => (
          <span
            dangerouslySetInnerHTML={{
              __html: `<span
                  title="${moment(params.row.asana_created_at).format(
                    "DD.MM.YYYY HH:mm:ss",
                  )}"
                >
                  ${formatRelativeDate(params.row.asana_created_at)}
                </span>`,
            }}
          />
        ),
      },
      {
        field: "name",
        headerName: "Number",
        sortable: false,
        flex: 1,
        type: "string",
        renderCell: (item) => (
          <>
            <Link to={item.row?.permalink_url} target="_blank">
              <span
                dangerouslySetInnerHTML={{
                  __html: item.value,
                }}
              />
            </Link>
          </>
        ),
      },
      {
        field: "notes",
        headerName: "Description",
        sortable: false,
        flex: 1,
        type: "string",
        renderCell: (item) => (
          <span
            dangerouslySetInnerHTML={{
              __html: item.value,
            }}
          />
        ),
      },
      {
        field: "status",
        headerName: "Status",
        sortable: false,
        maxWidth: 100,
        flex: 1,
      },
    ];
  }, []);

  return (
    <>
      <TaskList
        title={"Reporter tasks: " + reporter}
        tasksHeaders={tasksHeaders}
        filter={{ search_reporter: reporter }}
        reloadList={false}
      />
    </>
  );
});
